<template>
  <nav v-waypoint="{ active: true, callback: onScroll, options: scrollOptions}" class="primary-nav">
    <ul>
      <li class="indicator">
        <span />
      </li>
      <li>
        <a v-hover @click="scrollTo('about', 50)">About</a>
      </li>
      <li>
        <a v-hover @click="scrollTo('services', 0)">Services</a>
      </li>
      <li>
        <a v-hover @click="scrollTo('contact', 0)">Contact</a>
      </li>
      <li class="indicator">
        <span />
      </li>
    </ul>
  </nav>
</template>

<script>
import { gsap, ScrollToPlugin } from 'gsap/all'

export default {
  data: () => ({
    scrollOptions: {
      root: null,
      rootMargin: '-20px 0px 0px 0px',
      threshold: [0, 1]
    }
  }),
  methods: {
    scrollTo (id, offset) {
      gsap.registerPlugin(ScrollToPlugin)
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: `#${id}`,
          offsetY: offset
        }
      })
    },
    onScroll ({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_TOP) {
        gsap.to('.primary-nav', 0, {
          className: '+=primary-nav primary-nav--fixed'
        })
        gsap.fromTo('.scroll', 1, {
          autoAlpha: 1,
          y: 0
        }, {
          autoAlpha: 0,
          y: 50
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/styles/_variables';
  @import "../assets/styles/breakpoints";
  .primary-nav {
    position: absolute;
    transform: translateX(-50%) rotate(90deg) translateY(-50%);
    left: 20px;
    top: 50%;
    z-index: 100;
    @include breakpoint(sm) {
      display: none;
    }
    &.primary-nav--fixed {
      position: fixed;
      transform: translateX(-50%) rotate(90deg) translateY(-50%) translateX(50%);
      top: 0px;
    }
    ul {
      display: flex;
      li {
        margin: 0 10px;
        a {
          font-weight: 200;
          color: $sage;
          font-size: 1.1rem;
          transition: color .2s ease-in;
          &:hover {
            color: $gold;
            cursor: pointer;
          }
        }
        &.indicator {
          span {
            position: relative;
            top: 50%;
            transform: translateY(50%);
            width: 50px;
            height: 1px;
            display: block;
            background: $gold;
          }
        }
      }
    }
  }
</style>
